


























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PagesCoreView extends Vue {
  get styles() {
    const paddingTop = this.$vuetify.breakpoint.mdAndUp ? 175 : 100;
    const paddingBottom = this.$vuetify.breakpoint.mdAndUp ? 175 : 150;
    return {
      padding: `${paddingTop}px 0 ${paddingBottom}px 0`,
    };
  }
}
